import { Check, ChevronDown, Globe2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { changeAppLanguage, type AppLanguage } from "../i18n";
import { useCopy } from "../i18n/copy";
import { configApi } from "../api/config";

const options: Array<{ code: AppLanguage; short: string; label: string }> = [
  { code: "es", short: "ES", label: "Español (Ecuador)" },
  { code: "en", short: "EN", label: "English" },
];

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { tr, language } = useCopy();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const current = options.find((item) => item.code === language) || options[0];
  useEffect(() => {
    const close = (event: PointerEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("pointerdown", close);
    return () => document.removeEventListener("pointerdown", close);
  }, []);
  return (
    <div className={`language-switcher ${compact ? "compact" : ""}`} ref={root}>
      <button
        className="language-trigger"
        type="button"
        aria-label={tr("Cambiar idioma")}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <Globe2 />
        <span>{current.short}</span>
        <ChevronDown />
      </button>
      {open && (
        <div className="language-menu" role="menu">
          {options.map((option) => (
            <button
              key={option.code}
              type="button"
              role="menuitemradio"
              aria-checked={language === option.code}
              onClick={() => {
                void changeAppLanguage(option.code);
                if (localStorage.getItem("AUTH-TOKEN"))
                  void configApi.setLanguage(option.code).catch(() => undefined);
                setOpen(false);
              }}
            >
              <span>
                <strong>{option.short}</strong>
                <small>{tr(option.label)}</small>
              </span>
              {language === option.code && <Check />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
